<template>
  <v-dialog v-model="value" persistent max-width="1560px">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form" v-model="validForm">
        <v-container style="max-width:1560px">
          <v-layout wrap>

            <v-flex xs12 sm2 md2>

              <v-select
                md4
                clearable
                v-model="choosedTreatment"
                :items="protocolTreatments"
                color="primary"
                hide-no-data
                item-text="drug"
                item-value="id"
                label="Drug"
                :rules="[v => !!v || 'Drug is required!']"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_treatment_id')"
                return-object
              >
                <template slot="item" slot-scope="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.drug }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      item.dose
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm1 md1 v-if="choosedTreatment && choosedTreatment.open_drug">
              <v-text-field
                label="Drug name"
                v-model="item.open_drug_name"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_open_drug_name')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm1 md1>
              <v-text-field
                :label="'Dose ' + measure_unit"
                v-model="item.dose"
                :rules="[v => !!v || 'Dose is required!']"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_dose')"
              ></v-text-field>
            </v-flex>


            <v-flex xs12 sm2 md2>
              <v-select
                md4
                clearable
                v-model="item.action_taken"
                :items="actions"
                color="primary"
                hide-no-data
                label="Action taken"
                :rules="[v => !!v || 'Action taken is required!']"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_action_taken')"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm1 md1>
              <v-menu
                v-model="menu_datePicker_last_administration"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :rules="[v => !!v || 'Last Admin Date is required!']"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_last_administration')"
              >
                <template slot="activator">
                  <v-text-field
                    clearable
                    v-model="item.last_administration"
                    label="Admin Date"
                    readonly
                    :disabled="!$can('edit_field', 'adverse_event_has_treatment_last_administration')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  dark
                  v-model="item.last_administration"
                  no-title
                  @input="menu_datePicker_last_administration = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>


            <v-flex xs12 sm2 md2>
              <v-select
                md4
                clearable
                v-model="item.relationship"
                :items="relationships"
                color="primary"
                hide-no-data
                label="Investigator Relationship"
                :rules="[v => !!v || 'Investigator Relationship is required!']"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_relationship')"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm2 md2>
              <v-select
                md4
                clearable
                v-model="item.relationship_sponsor"
                :items="relationships"
                color="primary"
                hide-no-data
                label="Sponsor Relationship"
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_relationship_sponsor')"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm1 md1>
              <v-select
                md4
                clearable
                v-model="item.expectedness"
                item-value="value"
                item-text="label"
                :items="[{value:1, label:'Expected'}, {value:0, label:'Not Expected'}]"
                color="primary"
                label="Expectedness"
                hide-no-data
                :disabled="!$can('edit_field', 'adverse_event_has_treatment_expectedness')"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm1 md1>
              <!--v-btn @click="remove" text icon color="pink">
                <v-icon>mdi-delete</v-icon>
              </v-btn-->


                <v-tooltip top :disabled="!validForm || !$can('upsert', 'adverse_event_has_treatment')">
                  <template slot="activator" slot-scope="{ on }">

                    <v-btn
                      class="mx-1 font-weight-light"
                      color="purple"
                      small
                      :disabled="!validForm || !$can('upsert', 'adverse_event_has_treatment')"
                      @click="save()">{{ isNew ? 'Create' : 'Save'}}</v-btn>

                  </template>
                  <span>Add</span>
                </v-tooltip>

            </v-flex>

          </v-layout>
        </v-container>
      </v-form>

      <v-divider></v-divider>

      <v-data-table
        :items="aeTreatments"
        hide-actions
        :headers="[{ text: 'Drug', value: 'treatment.drug', sortable: false },
          { text: 'Dose', value: 'dose', sortable: false },
          { text: 'Action taken', value: 'action_taken', sortable: false },
          { text: 'Admin date', value: 'last_administration', sortable: false },
          { text: 'Investigator relationship', value: 'relationship', sortable: false },
          { text: 'Sponsor relationship', value: 'relationship_sponsor', sortable: false },
          { text: 'Expectedness', value: 'expectedness', sortable: false }]"
          
      >
      <template slot="items" slot-scope="{ item }" >
        <td><span v-if="item.treatment.pdf"><v-icon color="primary" @click="downloadPdf(item)">mdi-file-pdf</v-icon></span> {{ item.treatment.drug }} <span v-if="item.treatment.open_drug">({{item.open_drug_name}})</span></td>
        <td>{{ item.dose }} <span v-if="!item.treatment.open_drug && item.dose">{{item.treatment.measure_unit}}</span> </td>
        <td>{{ item.action_taken }}</td>
        <td>{{ item.last_administration }}</td>
        <td>{{ item.relationship }}</td>
        <td>{{ item.relationship_sponsor }}</td>
        <td>{{ item.expectedness == 1 ? 'Expected' : (item.expectedness == 0 ? 'Not Expected' : '') }}</td>
        <td class="text-xs-right">
          <a flat @click="edit(item)" v-if="$can('upsert', 'adverse_event_has_treatment')">
            <v-icon color="primary">mdi-pencil</v-icon>
          </a>
           {{item.adverse_event_account_id}}
          <a flat @click="remove(item)" v-if="canDelete(item)">
            <v-icon color="primary">mdi-delete</v-icon>
          </a>

          <v-tooltip top>
            <template slot="activator" slot-scope="{ on }">
              <a flat @click="openAuditTrail(item)" class="ml-2">
                <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
              </a>
            </template>
            <span>Audit Trail</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
 
      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >
      </v-flex>
    </material-card>

    <safety-pdf-preview-modal v-model="pdfPreview" :item="choosedTreatmentPdf" itemType="treatment"/>
    <v-dialog v-model="auditTrail.open" width="1200px">
      <!--  //BUG ALEXGORR -> errore console... prop nn definita ? -->
      <safety-audittrail-timeline v-if='auditTrail.open' entity="adverse_event_has_treatment" :entity_id='auditTrail.entityId' :fields="[{ text: 'Drug', value: 'treatment.drug', sortable: false },
          { text: 'Dose', value: 'dose', sortable: false },
          { text: 'Action taken', value: 'action_taken', sortable: false },
          { text: 'Admin date', value: 'last_administration', sortable: false },
          { text: 'Investigator relationship', value: 'relationship', sortable: false },
          { text: 'Sponsor relationship', value: 'relationship_sponsor', sortable: false },
          { text: 'Expectedness', value: 'expectedness', sortable: false }]"/>
    </v-dialog>
    <!--  //BUG ALEXGORR -> errore console... prop nn definita ? -->
  </v-dialog>
</template>

<script>
import { subject } from '@casl/ability';
import { post, getDetail } from "@/api/base_api";
import { getList as getProtocolTreatments, downloadPdf } from "@/api/treatment";
import { getList, upsert, remove as removeaetr} from "@/api/adverse_event_has_treatment";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    sae: Object,
    //issue vari
    savefun: Function
    //issue vari
  },
  data() {
    return {
      menu_datePicker_last_administration: false,
      validForm: true,
      validators,
      treatment: undefined,
      loadingTreatment: false,
      aeTreatments: [],
      item: {},
      protocolTreatments: [],
      choosedTreatment: {},
      choosedTreatmentPdf: {},
      protocol: {},
      isNew: true,
      auditTrail: {
        open: false,
        entityId: null
      },
      actions: [
        "Dose not changed",
        "Dose reduced",
        "Drug suspended",
        "Drug withdrawn",
        "Unknown",
        "Not applicable",
      ],
      relationships: [
        "Related",
        "Definitely related",
        "Probably related",
        "Possibly related",
        "Unlikely to be related",
        "Not related",
        "Unknown",
        "Not applicable"
      ],
      pdfPreview: false
    };
  },
  mounted() {

  },
  watch: {
    choosedTreatment(v) {
      if (v) {
        this.item.treatment_id = v.id;
      }
    },
    value(v) {
      if (v) {
        
        this.$refs.form.reset();

        getDetail('protocol', this.sae.protocol_id ).then( data => {
          this.protocol = data
          if(this.protocol.actions_taken && this.protocol.actions_taken.length) {
            this.actions = this.protocol.actions_taken
          }
        })

        getProtocolTreatments(
          { protocol_id: this.sae.protocol_id },
          { rowsPerPage: null }
        ).then(data => {
          this.protocolTreatments = data.data;
        });
        this.getData();
        this.item.adverse_event_id = this.sae.id;
        this.item.protocol_id = this.sae.protocol_id;
      }
    }
  },
  computed: {
    title() {
      return "Treatments for SAE (" + this.sae.cin + ")";
    },
    measure_unit() {
      if (this.choosedTreatment) {
        return "(" + this.choosedTreatment.measure_unit + ")";
      } else {
        return "";
      }
    },
    isMM() {
      return this.$store.getters.userObj.role == 'Medical Monitor'
    }
  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = `${item.adverse_event_id}_${item.treatment_id}`
      this.auditTrail.open = true
    },
    //issue vari
    getData(settreatments) {
      getList({adverse_event_id: this.sae.id}, {sortBy:"insert_at", descending:true, rowsPerPage:-1}).then( data => {
        this.aeTreatments = data.data;
        if (settreatments)
        {
          this.sae.treatments = ""
          for (let index = 0; index < this.aeTreatments.length; index++) {
            const element = this.aeTreatments[index];
            if (this.sae.treatments !== "") this.sae.treatments += ",";
            this.sae.treatments += element.treatment.drug;
            this.sae.treatments += " " + element.dose;
            if (element.action_taken) this.sae.treatments += " " + element.action_taken;
            if (element.last_administration) this.sae.treatments += " " + element.last_administration;
            if (element.relationship) this.sae.treatments += " " + element.relationship;
            if (element.relationship_sponsor) this.sae.treatments += " " + element.relationship_sponsor;
            if (element.expectedness) this.sae.treatments += " " + element.expectedness;
          }
          if (this.savefun)
          {
            if(this.isMM) {
              this.$root.$emit('isAeTreatmentUpdateMMUserEvent', this.isMM);
            }
            this.savefun()
          }
        }
      });
      //issue vari
    },
    close() {
      this.$emit("input", false);
    },
    canDelete(item) {
      return this.$can('delete', subject('adverse_event_has_treatment', item));
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }
      if(this.isMM) {
        this.item.mm_user = this.$store.getters.userObj.name + ' ' + this.$store.getters.userObj.surname
        this.item.mm_update = new Date().toISOString().slice(0, 19).replace('T', ' ')
      }
      if(this.item.expectedness == undefined) {
        this.item.expectedness = null
      }
      if(this.item.relationship_sponsor == undefined) {
        this.item.relationship_sponsor = null
      }
      upsert(this.item, this.isNew)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Ae treatment updated correctly",
            color: "success"
          });
          //issue vari
          this.getData(true);
          //issue vari
          this.$refs.form.reset();
          this.item.adverse_event_id = this.sae.id;
          
          if(this.isMM) {
            post('/mm_changed', {id: this.sae.id, 'mm_changed' : 1})
          }

        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Ae treatment update. " +
              e.response.data.message,
            color: "error"
          });
        })
        .finally(() => {
          this.isNew = true
        });
    },
    remove(aeTr) {
      removeaetr(aeTr).then( data => {
        //issue vari
        this.getData(true);
        //issue vari
      });
    },
    edit(item) {
      this.isNew = false
      this.item = JSON.parse(JSON.stringify(item));
      this.choosedTreatment = item.treatment;
    },
    downloadPdf(item) {
      // downloadPdf(item.treatment.id, item.treatment.pdf)
      this.choosedTreatmentPdf = item.treatment
      this.pdfPreview = true
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
